import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import homeReducer from '../features/home/redux/reducer';
import commonReducer from '../features/common/redux/reducer';
import sessionReducer from '../features/session/redux/reducer';
import notesReducer from '../features/notes/redux/reducer';
import chatReducer from '../features/chat/redux/reducer';
import thoughtJournalReducer from '../features/thought-journal/redux/reducer';
import foodJournalReducer from '../features/food-journal/redux/reducer';
import sleepJournalReducer from '../features/sleep-journal/redux/reducer';
import modulesReducer from '../features/modules/redux/reducer';
import dashboardReducer from '../features/dashboard/redux/reducer';
import profileReducer from '../features/profile/redux/reducer';
import feedsReducer from '../features/feeds/redux/reducer';
import groupsReducer from '../features/groups/redux/reducer';
import progressReducer from '../features/progress/redux/reducer';
import engagementReducer from '../features/engagement/redux/reducer';
import plannerReducer from '../features/planner/redux/reducer';
import overviewReducer from '../features/overview/redux/reducer';
import changePasswordReducer from '../features/change-password/redux/reducer';
import broadcastReducer from '../features/broadcast/redux/reducer';
import cognitoReducer from '../features/cognito/redux/reducer';
import newProfileReducer from '../features/new-profile/redux/reducer';
import prudentialReducer from '../features/prudential/redux/reducer';
import moodJournalReducer from '../features/mood-journal/redux/reducer';

// NOTE 1: DO NOT CHANGE the 'reducerMap' name and the declaration pattern.
// This is used for Rekit cmds to register new features, remove features, etc.
// NOTE 2: always use the camel case of the feature folder name as the store branch name
// So that it's easy for others to understand it and Rekit could manage theme.

const reducerMap = {
  router: routerReducer,
  home: homeReducer,
  common: commonReducer,
  session: sessionReducer,
  notes: notesReducer,
  chat: chatReducer,
  thoughtJournal: thoughtJournalReducer,
  foodJournal: foodJournalReducer,
  sleepJournal: sleepJournalReducer,
  modules: modulesReducer,
  dashboard: dashboardReducer,
  profile: profileReducer,
  feeds: feedsReducer,
  groups: groupsReducer,
  progress: progressReducer,
  engagement: engagementReducer,
  planner: plannerReducer,
  overview: overviewReducer,
  changePassword: changePasswordReducer,
  broadcast: broadcastReducer,
  cognito: cognitoReducer,
  newProfile: newProfileReducer,
  prudential: prudentialReducer,
  moodJournal: moodJournalReducer,
};

export default combineReducers(reducerMap);



// WEBPACK FOOTER //
// ./src/common/rootReducer.js